import { RadioAccordionSectionController } from './radioAccordionSection.controller';
import template from './radioAccordionSection.html';

export const radioAccordionSectionComponent = {
  name: 'radioAccordionSection',
  restrict: 'E',
  transclude: true,
  template,
  controller: RadioAccordionSectionController,
  controllerAs: 'vm',
  bindings: {
    header: '@',
    isOpen: '<',
    onOpen: '&'
  }
};
